import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { LoginResult } from 'tuapath-common/generated/schema';
import { VerifyOtpMutationArgs } from '../../dto';

type Result = { verifyOtp: LoginResult };
export const useVerifyOtp = (options?: MutationHookOptions<Result, VerifyOtpMutationArgs>) => {
  const mutation = gql`
    mutation verifyOtp($code: String!, $method: String!) {
      verifyOtp(code: $code, method: $method) {
        success
        sessionToken
        twoFactorRedirect
        reason
      }
    }
  `;

  return useMutation<Result, VerifyOtpMutationArgs>(mutation, options);
};

export default useVerifyOtp;
